// PRXT33Peel.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const PRXT33PeelData: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Prx T33 Peel - Elite Body Home Dubai",
            "description": "PRX-T33 Peel is a cutting-edge, non-invasive skin rejuvenation treatment that revitalizes the skin without the need for needles, surgery, or downtime.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/prx-t33-peel/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Prx T33 Peel - Elite Body Home Dubai",
                "description": "PRX-T33 Peel is a cutting-edge, non-invasive skin rejuvenation treatment that revitalizes the skin without the need for needles, surgery, or downtime.",
                "url": "https://elitebodyhome.com/services/prx-t33-peel/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-23T13:23:40+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/PRX-T33-Peel-in-elite-body-home-2-scaled.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/PRX-T33-Peel-in-elite-body-home-2-scaled.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "PRX T33 Peel",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Prx T33 Peel - Elite Body Home Dubai",
                "description": "PRX-T33 Peel is a cutting-edge, non-invasive skin rejuvenation treatment that revitalizes the skin without the need for needles, surgery, or downtime.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/PRX-T33-Peel-in-elite-body-home-2-scaled.jpg"
            },
        },
        "breadcrumbs": ["Home", "Services", "PRX T33 Peel"],
        "hero": {
            "title": "PRX T33 Peel",
            "subtitle": "Reveal Radiant Skin with PRX T33 Peel",
            "description": "PRX-T33 Peel: Non-Invasive Skin Rejuvenation Treatment This all-new peel offers the skin a combination of the bioactive effects of trichloroacetic acid (TCA), hydrogen peroxide, and kojic acid to target various skin concerns, from fine lines to hyperpigmentation and acne scars to dull skin. Ideal for those looking to improve the texture, tone and elasticity of their skin, the PRX-T33 Peel is virtually painless and gives immediate results."
        },
        "howItWorks": {
            "title": "How PRX-T33 Peel Works",
            "description": "The PRX-T33 Peel features a unique combination of ingredients that works in synergy to penetrate the layers of the skin without damaging the surface. The 33% TCA combined with hydrogen peroxide encourages the skin's regenerative processes with collagen-producing properties, whilst hydrating and protecting the skin. The brightening property of Kojic acid helps in reducing pigmentation and skin radiance."
        },
        "procedureSteps": {
            "heading": "The PRX-T33 Peel Procedure",
            "para": "The PRX-T33 Peel is a fast, painless procedure that typically lasts about 30 minutes.",
            "steps": [
                {
                    "title": "Skin Cleansing",
                    "desc": "Skin is thoroughly cleansed to eliminate waste or beauty products.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "Solution Application",
                    "desc": "PRX-T33 solution is applied in several layers, massaging it into the skin.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "Absorption Time",
                    "desc": "Leave solution on for several minutes to allow for absorption.",
                    "icon": "fa-regular fa-clock"
                },
                {
                    "title": "Final Care",
                    "desc": "After the peel, a moisturizer or calming serum is applied.",
                    "icon": "fa-solid fa-spa"
                }
            ]
        },
        "benefits": {
            "heading": "PRX-T33 Peel Benefits",
            "subheading": "",
            "para": "The PRX-T33 Peel has many benefits for anyone looking to improve their skin's appearance and texture. This treatment not only encourages collagen production but also assists in natural skin regeneration, resulting in gradual but cumulative enhancement of skin quality.",
            "items": [
                {
                    "title": "Enhances skin firmness",
                    "desc": "Stimulates collagen and elastin production for improved skin elasticity and firmness.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "Brightens complexion",
                    "desc": "Minimizes hyperpigmentation, dark spots, and uneven skin tone for luminous glow.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Refines skin texture",
                    "desc": "Reduces the appearance of fine lines, acne scars and enlarged pores.",
                    "icon": "fa-solid fa-hand-sparkles"
                },
                {
                    "title": "Safe for all skin types",
                    "desc": "Good for all skin types, even dark, sensitive, and combination skin.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "No downtime",
                    "desc": "Little to no visible peeling or redness and can resume daily activities immediately.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Non-invasive rejuvenation",
                    "desc": "Delivers visible anti-aging results without having to resort to renewal procedures.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "eligibility": {
            "heading": "PRX-T33 Peel: Who Is Suitable for It?",
            "subheading": "",
            "para": "The PRX-T33 Peel is a great choice for a broad range of people, especially anyone looking for visible changes to their skin with minimal recovery time. This peel is suitable for a range of skin concerns and is perfect for:",
            "items": [
                {
                    "title": "Aging signs",
                    "desc": "People who show signs of aging, such as fine lines and wrinkles.",
                    "icon": "fa-solid fa-user-clock"
                },
                {
                    "title": "Public figures",
                    "desc": "Models, actors, influencers and anyone in the spotlight who wants an instant glow for special occasions or lifestyle moments.",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "Hyperpigmentation",
                    "desc": "Those with hyperpigmentation or sun damage.",
                    "icon": "fa-solid fa-circle"
                },
                {
                    "title": "Acne scars",
                    "desc": "Acne scarring or uneven skin texture.",
                    "icon": "fa-solid fa-dot-circle"
                },
                {
                    "title": "Dull skin",
                    "desc": "Folks with dull or lackluster skin in need of a rejuvenation boost.",
                    "icon": "fa-solid fa-cloud-sun"
                }
            ]
        },
        "preparationTips": {
            "heading": "PRX-T33 Peel Preparation Guidelines",
            "subheading": "",
            "para": "Before Treatment X-rays are commonly used to diagnose fractures and assess overall oral health, but with some simple preparation, you can improve the treatment outcome and prevent possible complications.",
            "items": [
                {
                    "title": "Avoid sun exposure",
                    "desc": "Minimize exposure to direct sun on the treatment area for at least one week prior to your procedure to prevent irritation.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Discontinue retinoids",
                    "desc": "Avoid using any retinoidbased products or strong exfoliants a few days prior to the peel to minimise sensitivity.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Keep skin hydrated",
                    "desc": "In the days leading up to the treatment, make sure your skin is well moisturized as this will helps the peel absorb better.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "Consult a professional",
                    "desc": "Talk about your medical history and medications you are taking to avoid any potential interactions.",
                    "icon": "fa-solid fa-user-md"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "With results of the PRX-T33 Peel frequently visible after only 1st session, revealing brighter, smoother, younger looking skin. But, multiple sessions may be required for more serious concerns like acne scars or major pigmentation issues. The skin's collagen production also accumulates over time, resulting in a sustained improvement in elasticity and texture.",
            "items": [
                {
                    "title": "Immediate glow",
                    "desc": "The skin looks brighter & fresh immediately after first session.",
                    "icon": "fa-solid fa-sparkles"
                },
                {
                    "title": "Smoother skin texture",
                    "desc": "Reduced appearance of fine lines, wrinkles and acne scars.",
                    "icon": "fa-solid fa-hand-sparkles"
                },
                {
                    "title": "Improved skin elasticity",
                    "desc": "Increased collagen production, tighter and more elastic skin.",
                    "icon": "fa-solid fa-expand"
                },
                {
                    "title": "Long-lasting effects",
                    "desc": "With a series of treatments, results can last for months, particularly when combined with an effective skin care routine.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "Is there any downtime with PRX-T33 Peel?",
                    "answer": "No, PRX-T33 Peel does not cause visible peeling or require any downtime, allowing you to return to your routine immediately."
                },
                {
                    "question": "How soon will I see results?",
                    "answer": "Most patients notice improvements in skin texture and radiance after just one session, with optimal results seen after 3-4 treatments."
                },
                {
                    "question": "Is PRX-T33 Peel painful?",
                    "answer": "The treatment is generally well-tolerated with minimal discomfort. Some patients may experience a slight tingling sensation during the procedure."
                },
                {
                    "question": "Can I use PRX-T33 Peel in the summer?",
                    "answer": "Yes, the PRX-T33 Peel can be used year-round, including during the summer months, as it does not make the skin sensitive to UV rays."
                },
                {
                    "question": "What areas can be treated with PRX-T33?",
                    "answer": "PRX-T33 can be used on the face, neck, chest, and hands to improve skin texture, elasticity, and hydration."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/PRX-T33-Peel-in-elite-body-home-2-scaled.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/PRX-T33-Peel-in-elite-body-home-Dubai-1.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/PRX-T33-Peel-in-elite-body-home-Dubai-2.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/PRX-T33-Peel-in-elite-body-home-Dubai-3.jpg"
            ]
        },
        "product": {
            "id": 104,
            "title": "PRX-T33 Peel Treatment",
            "price": 699,
            "description": "Advanced non-invasive skin rejuvenation treatment that stimulates collagen production and revitalizes skin texture without downtime. Perfect for busy individuals seeking immediate results with no recovery period."
        }
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "تقشير PRX-T33 في دبي - ايليت بودي هوم",
            "description": "تقشير PRX-T33 هو علاج متطور لتجديد البشرة دون الحاجة إلى إبر أو جراحة أو فترة تعافي. احصل على بشرة مشرقة وشابة في عيادات ايليت بودي هوم بدبي.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/prx-t33-peel/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "تقشير PRX-T33 في دبي - ايليت بودي هوم",
                "description": "تقشير PRX-T33 هو علاج متطور لتجديد البشرة دون الحاجة إلى إبر أو جراحة أو فترة تعافي. احصل على بشرة مشرقة وشابة في عيادات ايليت بودي هوم بدبي.",
                "url": "https://elitebodyhome.com/services/prx-t33-peel/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-23T13:23:40+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/PRX-T33-Peel-in-elite-body-home-2-scaled.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/PRX-T33-Peel-in-elite-body-home-2-scaled.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "تقشير PRX-T33",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "تقشير PRX-T33 في دبي - ايليت بودي هوم",
                "description": "تقشير PRX-T33 هو علاج متطور لتجديد البشرة دون الحاجة إلى إبر أو جراحة أو فترة تعافي. احصل على بشرة مشرقة وشابة في عيادات ايليت بودي هوم بدبي.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/PRX-T33-Peel-in-elite-body-home-2-scaled.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "تقشير PRX-T33"],
        "hero": {
            "title": "تقشير PRX-T33",
            "subtitle": "احصلي على بشرة مُشرقة ومجددة مع تقشير PRX-T33",
            "description": "تقشير PRX-T33: علاج غير جراحي لتجديد البشرة. يعتمد هذا التقشير المتطور على مزيج فعال من حمض التريكلوروسيتيك (TCA)، وبيروكسيد الهيدروجين، وحمض الكوجيك، ليستهدف مجموعة واسعة من مشكلات البشرة مثل الخطوط الدقيقة، وفرط التصبغ، وندبات حب الشباب، والبشرة الباهتة. يُعد مثاليًا لمن يرغب في تحسين ملمس البشرة وتوحيد لونها واستعادة مرونتها، ويتميز بأنه إجراء غير مؤلم تقريبًا ويوفر نتائج فورية."
        },
        "howItWorks": {
            "title": "كيف يعمل تقشير PRX-T33؟",
            "description": "يعتمد تقشير PRX-T33 على تركيبة فريدة من المكونات المتناغمة التي تتغلغل في طبقات الجلد دون الإضرار بسطح البشرة. يعمل حمض التريكلوروسيتيك بتركيز 33%، بالتعاون مع بيروكسيد الهيدروجين، على تحفيز عملية تجديد البشرة وتعزيز إنتاج الكولاجين، مع الحفاظ على ترطيب البشرة وحمايتها. كما يُساهم حمض الكوجيك بخصائصه المُفَتحة في تقليل التصبغات وتحسين إشراقة البشرة."
        },
        "procedureSteps": {
            "heading": "خطوات إجراء تقشير PRX-T33",
            "para": "يُعد تقشير PRX-T33 إجراءً سريعاً وغير مؤلم، ويستغرق عادةً حوالي 30 دقيقة فقط.",
            "steps": [
                {
                    "title": "تنظيف البشرة",
                    "desc": "تبدأ الجلسة بتنظيف البشرة جيداً لإزالة أي شوائب أو بقايا مستحضرات تجميل.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "تطبيق المحلول",
                    "desc": "يُستخدم محلول PRX-T33 على المنطقة المستهدفة مثل الوجه، أو الرقبة، أو الصدر، أو اليدين.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "وقت الامتصاص",
                    "desc": "يقوم الطبيب المتخصص بتدليك المحلول بلطف على البشرة على شكل طبقات، لتتمكن المواد الفعالة من التغلغل بعمق.",
                    "icon": "fa-regular fa-clock"
                },
                {
                    "title": "العناية النهائية",
                    "desc": "وفي نهاية الجلسة، يُستخدم مرطب أو سيروم مهدئ لتهدئة البشرة وتعزيز الترطيب.",
                    "icon": "fa-solid fa-spa"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد تقشير PRX-T33",
            "subheading": "",
            "para": "يُعد تقشير PRX-T33 خياراً مثالياً لكل من يرغب في تحسين مظهر البشرة وملمسها، حيث لا يقتصر دوره على تحفيز إنتاج الكولاجين فحسب، بل يساهم أيضاً في تجديد البشرة طبيعياً، مما يؤدي إلى تحسن تدريجي وتراكمي في جودة البشرة.",
            "items": [
                {
                    "title": "زيادة تماسك البشرة",
                    "desc": "يُحفز إنتاج الكولاجين والإيلاستين، مما يعزز مرونة البشرة وتماسكها.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "تفتيح لون البشرة",
                    "desc": "يساعد على تقليل التصبغات، والبقع الداكنة، وتفاوت لون البشرة، مما يمنحها إشراقة طبيعية.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "تحسين ملمس البشرة",
                    "desc": "يساهم في تقليل مظهر الخطوط الدقيقة، وندبات حب الشباب، والمسام الواسعة.",
                    "icon": "fa-solid fa-hand-sparkles"
                },
                {
                    "title": "آمن لجميع أنواع البشرة",
                    "desc": "يناسب البشرة الفاتحة، والداكنة، والحساسة، والمختلطة.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "لا يتطلب فترة تعافي",
                    "desc": "لا يسبب تقشيراً ظاهراً أو احمراراً، ويمكن العودة للأنشطة اليومية فوراً بعد الجلسة.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "تجديد غير جراحي للبشرة",
                    "desc": "يوفر نتائج واضحة لمقاومة علامات التقدم في العمر دون اللجوء إلى إجراءات تجميلية مؤلمة.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "eligibility": {
            "heading": "لمن يُناسب تقشير PRX-T33؟",
            "subheading": "",
            "para": "يُعد تقشير PRX-T33 خياراً ممتازاً لمجموعة واسعة من الأشخاص، خاصةً لمن يبحثون عن تحسين واضح في مظهر بشرتهم دون الحاجة إلى فترة تعافٍ طويلة.",
            "items": [
                {
                    "title": "علامات التقدم في العمر",
                    "desc": "للأشخاص الذين يعانون من علامات التقدم في العمر مثل الخطوط الدقيقة والتجاعيد.",
                    "icon": "fa-solid fa-user-clock"
                },
                {
                    "title": "الشخصيات العامة",
                    "desc": "للعارضات، والممثلين، والمؤثرين، وكل من يعمل تحت الأضواء ويبحث عن إشراقة فورية استعداداً لمناسبات خاصة أو جلسات تصوير.",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "فرط التصبغ",
                    "desc": "للأشخاص الذين يعانون من التصبغات أو آثار أضرار الشمس على بشرته.",
                    "icon": "fa-solid fa-circle"
                },
                {
                    "title": "ندبات حب الشباب",
                    "desc": "للحالات التي تعاني من ندبات حب الشباب أو ملمس غير متجانس للبشرة.",
                    "icon": "fa-solid fa-dot-circle"
                },
                {
                    "title": "بشرة باهتة",
                    "desc": "للأشخاص الذين يعانون من بهتان البشرة ويحتاج إلى تعزيز تجديد البشرة.",
                    "icon": "fa-solid fa-cloud-sun"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد للعلاج",
            "subheading": "",
            "para": "يجب اتباع التعليمات التالية قبل العلاج لضمان أفضل نتيجة ممكنة من جلسة تقشير PRX-T33 وتفادي أي مضاعفات محتملة:",
            "items": [
                {
                    "title": "تجنب التعرض للشمس",
                    "desc": "يُنصح بتجنب تعرض المنطقة المستهدفة بالتقشير لأشعة الشمس المباشرة لمدة لا تقل عن أسبوع قبل الجلسة، لتقليل خطر التهاب البشرة.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "التوقف عن استخدام الريتينويدات",
                    "desc": "امتنع عن استخدام أي منتجات تحتوي على الريتينويد أو المقشرات القوية قبل التقشير بعدة أيام لتقليل حساسية الجلد.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "الحفاظ على ترطيب البشرة",
                    "desc": "احرص على أن تكون بشرتك مرطبة بشكل جيد في الأيام السابقة للجلسة، حيث يساعد ذلك في امتصاص أفضل للمُقشر.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "استشارة طبيب متخصص",
                    "desc": "تأكد من مناقشة تاريخك الطبي الكامل وأي أدوية تتناولها مع الطبيب المتخصص لتجنب أي تداخلات محتملة مع العلاج.",
                    "icon": "fa-solid fa-user-md"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "",
            "para": "تظهر نتائج تقشير PRX-T33 في كثير من الحالات بعد الجلسة الأولى مباشرةً، حيث تكون البشرة أكثر إشراقًا ونعومةً وأكثر شبابًا. ومع ذلك، قد تكون هناك حاجة إلى عدة جلسات لعلاج الحالات الأعمق مثل ندبات حب الشباب أو التصبغات الشديدة.",
            "items": [
                {
                    "title": "إشراقة فورية",
                    "desc": "تبدو البشرة أكثر نضارة وحيوية فورًا بعد الجلسة الأولى.",
                    "icon": "fa-solid fa-sparkles"
                },
                {
                    "title": "ملمس أكثر نعومة",
                    "desc": "تقل الخطوط الدقيقة، والتجاعيد، وندبات حب الشباب بشكل واضح.",
                    "icon": "fa-solid fa-hand-sparkles"
                },
                {
                    "title": "تحسن في مرونة البشرة",
                    "desc": "يزداد إنتاج الكولاجين مما يمنح البشرة تماسكًا ومرونةً أكبر.",
                    "icon": "fa-solid fa-expand"
                },
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "يمكن أن تستمر النتائج لعدة أشهر عند الخضوع لسلسلة من الجلسات، وخاصةً عند الالتزام بروتين فعّال للعناية بالبشرة.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": []
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "هل يتطلب تقشير PRX-T33 فترة تعافي؟",
                    "answer": "لا، لا يسبب تقشير PRX-T33 تقشيرًا ظاهرًا أو يتطلب فترة تعافي، مما يسمح لك بالعودة إلى روتينك اليومي فورًا."
                },
                {
                    "question": "متى سأرى نتائج العلاج؟",
                    "answer": "يلاحظ معظم المرضى تحسنًا في ملمس البشرة وإشراقتها بعد الجلسة الأولى، مع ظهور النتائج المثالية بعد 3-4 جلسات."
                },
                {
                    "question": "هل تقشير PRX-T33 مؤلم؟",
                    "answer": "يُحتمل جيدًا العلاج مع حد أدنى من الانزعاج. قد يشعر بعض المرضى بوخز خفيف أثناء الإجراء."
                },
                {
                    "question": "هل يمكن استخدام تقشير PRX-T33 في الصيف؟",
                    "answer": "نعم، يمكن استخدام تقشير PRX-T33 على مدار العام، بما في ذلك أشهر الصيف، لأنه لا يجعل البشرة حساسة للأشعة فوق البنفسجية."
                },
                {
                    "question": "ما هي المناطق التي يمكن علاجها بتقشير PRX-T33؟",
                    "answer": "يمكن استخدام PRX-T33 على الوجه، والرقبة، والصدر، واليدين لتحسين ملمس البشرة ومرونتها وترطيبها."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }

};
